import './App.css';
import {letterScores} from  './GameLogic';
import React, { useState, useEffect, useRef } from 'react';

import { initializeApp } from "firebase/app";
import { getDatabase, ref, set, onValue, get, push } from "firebase/database";
import { getAuth, signInAnonymously, signOut } from 'firebase/auth';

import wordList from 'word-list-json';

const firebaseConfig = {
  apiKey: "AIzaSyB9kS_EBbxnLiN8vivsKEN9rZRhDBnYOIk",
  authDomain: "alphabattle-c1277.firebaseapp.com",
  projectId: "alphabattle-c1277",
  storageBucket: "alphabattle-c1277.appspot.com",
  messagingSenderId: "1015370046043",
  appId: "1:1015370046043:web:7a58626a842ce952993d7e",
  measurementId: "G-VCB3G3XX0H"
};

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const auth = getAuth(app);

function GameOver({gameObject, winnerNumber, playerNumber}){  // REDNER THIS WHEN GAME IS TOTALLY OVER
  const backgroundImageStyle = (winnerNumber === playerNumber)
    ? 'gameoverContainer'
    : 'gameoverContainer2'

  console.log(winnerNumber + ' winnging num  .  player num ' + playerNumber)
  //console.log(backgroundImageStyle)

  useEffect(() => {
    //console.log('The component has updated with new props.');
  }, [winnerNumber, playerNumber]);  // This useEffect runs whenever winnerNumber or playerNumber changes

  
  return(
    <div className={`gameoverContainer ${backgroundImageStyle}`}>
      <div className='headerOVER'>
        <div className='player'>P1</div>
        <div className='player'>PLAYER {playerNumber && playerNumber}</div>
        <div className='player'>P2</div>
      </div>
      <div className='recapCell'><span></span> ROUND 4 SCORE <span></span></div>
      <div className='recapCell'>ROUND 5 SCORE</div>
      <div className='recapCell'>ROUND 6 SCORE</div>
      <div className='recapCell'>ROUND 7 SCORE</div>
      <div className='recapCell'>ROUND 8 SCORE</div>
      <div className='recapCell'>ROUND 9 SCORE</div>
      <div className='recapCell'>ROUND 10 SCORE</div>
      <div className='recapCell'>
        <span className='totalOver'>{gameObject.player1points}</span> TOTAL SCORE 
        <span className='totalOver'>  {gameObject.player2points}</span>
      </div>
    </div>
  )
}

function createDeck(){
  const alphabetOLD = 'abcdefghijklmnopqrstuvwxyz'
  const alphabet = 'abcdefghijklmnopqrstuvwxyzaaaaiiiiooooeeeeeeuunrtnrts'
  const deck = [];
  for(let i = 0;  i<6; i++ ){
    alphabet.split('').forEach((letter)=>{deck.push(letter)});
  }
  for (let i = deck.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [deck[i], deck[j]] = [deck[j], deck[i]];
  }

  const capitalizedDeck = deck.map(letter => letter.toUpperCase());

  //console.log(capitalizedDeck);

  return capitalizedDeck;
}

var spelled_index = 1;
var spelledListofIncides = [];
var spelled_word5 = '';
var round_pts = 0;
var starting_round_number = 4;



// bjJotv6UgJaKLxTpxxoIjBq8jmH3     // GAME ID 

function Game({SetWinnerNumber, SetGamefinished, setGameObject, playerNumber, currentGameID, loginID, setGameRunning, gameObject}){

  const [gameOver, setGameOver] = useState(false);
  const [spelledLetters, setSpelledLetters] = useState([]);
  const [spelledLetters2, setSpelledLetters2] = useState([]);
  const [spelledLetters3, setSpelledLetters3] = useState([]);
  const [draw_card_index, setDraw_card_index] = useState(0);
  const [spellLimit, setSpellLimit] = useState(false);
  const [shuffleLimit, setShuffleLimit] = useState(false);
  const [myTurn, setMyTurn] = useState(false);
  const [usedIndexes, setUsedIndexes] = useState([]);
  const [roundPoints, setRoundPoints] = useState(0);
  const [allIndices, SetallIndices] = useState([]);
  const [lastTurn, setLastTurn] = useState(false);
  const [promptActive, setPromptActive] = useState(false);




  async function loadGameData(ID){
    const dataRef = ref(database,  'games/' + ID);
    try {
      const snapshot = await get(dataRef);
      if (snapshot.exists()) {
        //console.log(snapshot.val());
        return snapshot.val();
      } else {
        console.log("No data available for key:", ID);
        return null;
      }
    }catch(err){console.log('loadGameData funnction error: ' + err)}
  }

  function handleClear(){
    spelled_index = 1;
    setSpelledLetters([]);
    setSpelledLetters2([]);
    setSpelledLetters3([]);
    setSpellLimit(false);
    setUsedIndexes([]);
    setRoundPoints(0);
    spelledListofIncides = [];
    spelled_word5 = '';
    round_pts = 0;
    SetallIndices([]);
  }
  
  function handleTouch (index) {
    //console.log('HANDLE TOUCH CALLED')
    if (spellLimit) {
      return;
    }
    function updateSpelledLetters (spelledLetters, index) {  // Function to set Array of Indexes of Letters
      if (spelledLetters.includes(index)) { 
        return spelledLetters.filter(i => i !== index); // Remove the index (and thus the letter)
      } else {return [...spelledLetters, index];} // Add the index (and thus the letter)
    };
    if (spelled_index === 1) {
      setSpelledLetters(prev => updateSpelledLetters(prev, index));
      spelledListofIncides = updateSpelledLetters(spelledListofIncides, index);
      console.log('SPELLED LETTERS (STATE COMPONENT): ' + spelledLetters);
      console.log('SPELLED LIST OF INDEXES (STATE COMPONENT): ' + spelledListofIncides);
    } else if (spelled_index === 2) {
      setSpelledLetters2(prev => updateSpelledLetters(prev, index));
      spelledListofIncides = updateSpelledLetters(spelledListofIncides, index);
    } else if (spelled_index === 3) {
      setSpelledLetters3(prev => updateSpelledLetters(prev, index));
      spelledListofIncides = updateSpelledLetters(spelledListofIncides, index);
    };
    var spelled_word4 = '';
    spelledLetters.forEach((val) => {
      if (val !== 11) {
        let temp_letter = playerNumber === 1 ? gameObject.player1hand[val] : gameObject.player2hand[val];
        spelled_word4 += temp_letter;
      } else if (val === 11) {
        let temp_letter = gameObject.drawcard[draw_card_index];
        spelled_word4 += temp_letter;
      }
    });
    if (spelledListofIncides.length > 0) {
      let lastItem = spelledListofIncides[spelledListofIncides.length - 1];
      console.log('INDEX OF LETTER CLICKED: ' + lastItem);
      if (lastItem !== 11) {
        let temp_letter = playerNumber === 1 ? gameObject.player1hand[lastItem] 
        : gameObject.player2hand[lastItem];
        console.log(temp_letter)
        round_pts += calculatePoint(temp_letter)
      } else if (lastItem === 11) {
        let temp_letter = gameObject.drawcard[draw_card_index];
        console.log(temp_letter)
        round_pts += calculatePoint(temp_letter)
      }
    }
    console.log('ROUND POINTS: ' + round_pts);
    console.log('SPELLED LIST OF INDEXES: ' + spelledListofIncides);
    console.log('LETTERS INDICES (STATE): ' + spelledLetters + spelledLetters2 + spelledLetters3);
    setRoundPoints(round_pts);
    SetallIndices(spelledListofIncides);
  };
  
  function handleLogOutClick(){
    console.log('BACK TO THE LOGIN SCREEN ' + loginID); 
    setGameRunning();
    signOut(auth).then(() => {
      console.log('User signed out successfully');
    }).catch((error) => {
      console.error('Error signing out:', error);
    });
  }

  function handleClickSpellBtn(){
    if(spelled_index < 3){
      spelled_index += 1;
    }

  }

  function calculatePoint(letter){
    let point = 0;
    point += letterScores[letter];
    console.log('calculatePoint called: ' + point);
    return point
  }

  function calculatePoints(word){{
    let points = 0;
    word.split('').forEach((letter)=>{
      points += letterScores[letter];
    })
    console.log('calculatePoints called: ' + points);
    return points;
  }
  }

  async function handleEndTurn(){
    const gameRef = ref(database, 'games/' + currentGameID);

    if(!myTurn){
      console.log('ITS NOT MY TURN');
      displayPrompt('ITS NOT UR TURN YET');
      return
    }

    const totalLength = spelledLetters.length + spelledLetters2.length + spelledLetters3.length;
    if(totalLength == 0){
      //HANDLE DISCARDING THE DISCARD CARD - KEEP HAND THE SAME - AKA YOU HAVE NOT CLICKED ANY CARDS
      console.log('YOU ARE ENDING YOUR TURN AND KEEPING HAND THE SAME (DISCARDING THE DRAW CARD)');
      const {lastcard, ...rest} = gameObject;
      const newGameObj = {...rest, state: (playerNumber == 1 ? 'p2' : 'p1'), 
      player1prompt: (playerNumber == 1 ? 'WAITING ON OPP' : 'OPP PASSED'),
      player2prompt: (playerNumber == 1 ? 'OPP PASSED' : 'WAITING ON OPP')}

      set(gameRef, newGameObj)
      return
    }
    if(totalLength < gameObject.round){
      console.log('YOU HAVENT USED ALL YOUR LETTERS');
      displayPrompt('USE ALL YOUR CARDS');
      return
    }

    var spelled_word = '';
    spelledLetters.forEach((val) => {
      if (val !== 11) {
        let temp_letter = playerNumber === 1 ? gameObject.player1hand[val] : gameObject.player2hand[val];
        spelled_word += temp_letter;
      } else if (val === 11) {
        let temp_letter = gameObject.drawcard[draw_card_index];
        spelled_word += temp_letter;
      }
    });
    var spelled_word2 = '';
    spelledLetters2.forEach((val) => {
      if (val !== 11) {
        let temp_letter = playerNumber === 1 ? gameObject.player1hand[val] : gameObject.player2hand[val];
        spelled_word2 += temp_letter;
      } else if (val === 11) {
        let temp_letter = gameObject.drawcard[draw_card_index];
        spelled_word2 += temp_letter;
      }
    });
    var spelled_word3 = '';
    spelledLetters3.forEach((val) => {
      if (val !== 11) {
        let temp_letter = playerNumber === 1 ? gameObject.player1hand[val] : gameObject.player2hand[val];
        spelled_word3 += temp_letter;
      } else if (val === 11) {
        let temp_letter = gameObject.drawcard[draw_card_index];
        spelled_word3 += temp_letter;
      }
    });

    console.log('YOU SPELLED: ' + spelled_word + ' and ' + spelled_word2 + ' and ' + spelled_word3)

    // POINTS

    const point1 = calculatePoints(spelled_word)
    const point2 = calculatePoints(spelled_word2)
    const point3 = calculatePoints(spelled_word3)
    var final_score = point1 + point2 + point3;

    const result1 = checkSpelling(spelled_word);
    const result2 = checkSpelling(spelled_word2);
    const result3 = checkSpelling(spelled_word3);

    console.log('WORD 1 is: ' + result1);
    console.log('WORD 2 is: ' + result2);
    console.log('WORD 3 is: ' + result3);

    console.log('LENGTH 1: ' + spelled_word.length)
    console.log('LENGTH 2: ' + spelled_word2.length)
    console.log('LENGTH 3: ' + spelled_word3.length)

    
    
    function findMissingNumbers(arr) {
      const total_array = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 11];
      const referenceArray = [...total_array.slice(0, gameObject.round), 11];
      const missingNumbers = referenceArray.filter(num => !arr.includes(num));
    
      return missingNumbers;
    }

    const missing_index = findMissingNumbers(spelledListofIncides);
    console.log('MISSING INDEX NUMBER (aka which card is leftover): ' + missing_index);
    
    var p1_unwanted = gameObject.player1hand[missing_index];
    var p2_unwanted = gameObject.player2hand[missing_index];

    if(missing_index == 11){
      p1_unwanted = gameObject.drawcard[0];
      p2_unwanted = gameObject.drawcard[0];
    }
    
    console.log('UNWANTED CARDS: ' + p1_unwanted + p2_unwanted);

    var final_card = '';

    if(playerNumber == 2){
      final_card = p2_unwanted
    }else{final_card = p1_unwanted}

    console.log('FINAL DISCARD CARD:  ' + final_card);

    var word_with_points_prompt = 'They spelled ' + spelled_word + ' for ' + point1 + ' points';
    if(spelled_word2.length > 0 && spelled_word3.length == 0){
      word_with_points_prompt = 'They spelled ' + spelled_word + ' and ' + spelled_word2 + ' for ' + final_score + ' points';

    }else if (spelled_word2.length > 0 && spelled_word3.length > 0){
      word_with_points_prompt = 'They spelled ' + spelled_word + ', ' + spelled_word2 + ' and ' + spelled_word3 + ' for ' + final_score + ' points';

    }

    if(lastTurn){

      // VALIDATE WORDS SPELLED AND HANDLE LEFT OVER LETTERS (WHICH ARE ANY INCORRECTLY SPELLED WORDS)

      if(!result1){
        final_score = final_score - (point1 * 2);
      }
      if(!result2){
        final_score = final_score - (point2 * 2);
      }
      if(!result3){
        final_score = final_score - (point3 * 2);
      }

      var word_with_points_prompt2 = 'They spelled ' + spelled_word + ' for ' + final_score + ' points';
      if(spelled_word2.length > 0 && spelled_word3.length == 0){
        word_with_points_prompt2 = 'They spelled ' + spelled_word + ' and ' + spelled_word2 + ' for ' + final_score + ' points';

      }else if (spelled_word2.length > 0 && spelled_word3.length > 0){
        word_with_points_prompt2 = 'They spelled ' + spelled_word + ', ' + spelled_word2 + ' and ' + spelled_word3 + ' for ' + final_score + ' points';
      }
      


      console.log('THIS IS THE FINAL TURN OF EITHER PLAYER');
      if(playerNumber == 1 && gameObject.state == 'p1'){
        console.log('PLAYER ' + playerNumber + ' IS ENDING FINAL TURN' );
        const newData = {...gameObject, state: 'over', finalcard: final_card, 
        player1points: gameObject.player1points + final_score,
        player2prompt: word_with_points_prompt2, player1prompt: 'GAME OVER' }
        set(gameRef, newData);
        setLastTurn(false);
        return
      }else if(playerNumber == 2 && gameObject.state == 'p2'){
        console.log('PLAYER ' + playerNumber + ' IS ENDING FINAL TURN' );
        const newData = {...gameObject, state: 'over', finalcard: final_card, 
        player2points: gameObject.player2points + final_score,
        player2prompt: 'GAME OVER', player1prompt: word_with_points_prompt2 }
        set(gameRef, newData);
        setLastTurn(false);
        return
      }
    }



    /// ENFORCE SPELLING RULES

    if(spelled_word2.length > 0 && spelled_word3.length == 0){
      console.log('CHECK 2 WORDS');
      if(!result1 || !result2){
        if(playerNumber == 1){
          gameObject.player1prompt = spelled_word + ' or ' + spelled_word2 + ' is not a word. Try again';
        }else{
          gameObject.player2prompt = spelled_word + ' or ' + spelled_word2 + ' is not a word. Try again';
        }
        handleClear();
        return
      }
    }else if(spelled_word3.length > 0){
      console.log('CHECK 3 WORDS');
      if(!result1 || !result2 || !result3){
        if(playerNumber == 1){
          gameObject.player1prompt = spelled_word + ', ' + spelled_word2 + ' or ' + spelled_word3 + ' is not a word. Try again';
        }else{
          gameObject.player2prompt = spelled_word + ', ' + spelled_word2 + ' or ' + spelled_word3 + ' is not a word. Try again';
        }
        handleClear();
        return
      }
    }else if(spelled_word2.length == 0 && spelled_word3.length == 0 && spelled_word.length > 2){
      console.log('CHECK 1 WORD ONLY');
      if(!result1){
        console.log(spelled_word + ' is not a word!!!');
        if(playerNumber == 1){
          gameObject.player1prompt = spelled_word + ' is not a word. Try again';
        }else{
          gameObject.player2prompt = spelled_word + ' is not a word. Try again';
        }
        handleClear();
        return
      }
    }else{console.log('AN UNCAUGHT CASE HAPPENED WHEN CHECKING SPELLING')}



    if(playerNumber == 1 && gameObject.state == 'p1'){
      console.log('END TURN CLICKED. PLAYER' + playerNumber + ' IS ENDING TURN' );
      const newData = {...gameObject, state: 'p2', finalcard: final_card, 
      player1points: gameObject.player1points + final_score,
      player2prompt: word_with_points_prompt, player1prompt: 'WAITING FOR OPP' }
      set(gameRef, newData);
    }else if(gameObject.state == 'new'){
      console.log('FIRST (AND FINAL FOR THEM) MOVE MADE BY PLAYER: ' + playerNumber + gameObject.state);
      var correct_state = 'p1';
      var p1prompt = '';
      var p2prompt = '';
      if(playerNumber == 1){
        correct_state = 'p2';
        p1prompt = 'LAST TURN MADE';
        p2prompt = word_with_points_prompt;
        var newData = {...gameObject, state: correct_state, finalcard: final_card, 
          player1points: gameObject.player1points + final_score,
          player1prompt: p1prompt, player2prompt: p2prompt}
      }else{
        p2prompt = 'LAST TURN MADE';
        p1prompt = word_with_points_prompt;
        var newData = {...gameObject, state: correct_state, finalcard: final_card, 
          player2points: gameObject.player2points + final_score,
          player1prompt: p1prompt, player2prompt: p2prompt}
      }
      set(gameRef, newData);
    }else if(playerNumber == 2 && gameObject.state == 'p2'){
      console.log('END TURN CLICKED. PLAYER' + playerNumber + ' IS ENDING TURN SUCESSFULLY' + currentGameID);
      const newData = {...gameObject, state: 'p1', finalcard: final_card, 
      player2points: gameObject.player2points + final_score,
      player2prompt: 'WAITING FOR OPP', player1prompt: word_with_points_prompt }
      set(gameRef, newData);
    }

    setMyTurn(false);
    setShuffleLimit(true);
  }

  function handleDrawCard(){
    if(spellLimit){return}
    console.log('DRAW CARD CLICKED');
    if(spelled_index == 1){
      const letter = gameObject.drawcard[draw_card_index];
      setSpelledLetters(prev => {
        console.log([...prev, letter]);
        return [...prev, letter]; // Add letter
    });
    }else if(spelled_index == 2){
      const letter = gameObject.drawcard[draw_card_index];
      setSpelledLetters2(prev => {
      if (!prev.includes(letter)) {
        return [...prev, letter]; // Add letter
      } else {
        return prev.filter(l => l !== letter); // Remove letter
      }
    });
    }else if(spelled_index == 3){
      const letter = gameObject.drawcard[draw_card_index];
      setSpelledLetters3(prev => {
      if (!prev.includes(letter)) {
        return [...prev, letter]; // Add letter
      } else {
        return prev.filter(l => l !== letter); // Remove letter
      }
    });
    }
  }

  function checkSpelling(word){
    return wordList.includes(word.toLowerCase());
  }

  function displayPrompt(message){
    console.log(message);
    if(playerNumber == 1){
      setGameObject(prev => {
        return {...prev, player1prompt: message};
      });
    }else if(playerNumber == 2){
      setGameObject(prev => {
        return {...prev, player2prompt: message};
      });
    }

  }

  function handleDiscard(){
    if(!myTurn){
      console.log('YOU CANT DISCARD WHEN ITS NOT YOUR TURN');
      displayPrompt('ITS NOT YOUR TURN');
      return
    }
    if(lastTurn){
      displayPrompt('YOU MUST GO OUT');
      console.log('YOU CANT DISCARD ON YOUR FINAL TURN');
      handleClear();
      return
    }
    if(spelledLetters.length == 1  && spelledLetters2.length < 1 && spelledLetters3.length < 1 
      && spelledLetters[0] !== 11){ // the singley played card is not the draw card (for now)
      console.log('DISCARD ELIGIBLE: ' + spelledLetters[0]);
      displayPrompt('DISCARD CLIKCED');

      const gameRef = ref(database, 'games/' + currentGameID);
      
      if(playerNumber == 1 && gameObject.state == 'p1'){
        const card_index_to_discard = spelledListofIncides[0];
        const draw_card_to_add = gameObject.drawcard[draw_card_index];
        console.log('PLAYER' + playerNumber + ' IS DISCARDING: ' 
        + gameObject.player1hand[card_index_to_discard] + ' and is adding ' + draw_card_to_add);
        var new_hand = gameObject.player1hand;
        new_hand += draw_card_to_add;
        new_hand = new_hand.slice(0, card_index_to_discard) + new_hand.slice(card_index_to_discard + 1)
        console.log(new_hand);
        const card_to_add = gameObject.player1hand[card_index_to_discard];
        console.log(card_to_add);
        var new_draw_list = gameObject.drawcard.slice(1);
        new_draw_list.unshift(card_to_add);
        console.log('NEW DRAW CARD LIST: ' +  new_draw_list);
        setSpelledLetters([]);
        spelledListofIncides = [];

        const newData = {...gameObject, drawcard: new_draw_list, player1hand: new_hand, state: 'p2', 
        player2prompt: 'YOUR TURN', player1prompt: 'WAITING FOR OPP' }
        set(gameRef, newData);

      }else if(gameObject.state == 'new'){
        const card_index_to_discard = spelledListofIncides[0];
        const draw_card_to_add = gameObject.drawcard[draw_card_index];
        console.log('PLAYER' + playerNumber + ' IS DISCARDING: ' 
        + gameObject.player1hand[card_index_to_discard] + ' and is adding ' + draw_card_to_add);
        var new_hand = gameObject.player2hand;
        if(playerNumber == 1){
          new_hand = gameObject.player1hand;
        }
        new_hand += draw_card_to_add;
        new_hand = new_hand.slice(0, card_index_to_discard) + new_hand.slice(card_index_to_discard + 1)
        console.log('YOUR NEW HAND IS: ' + new_hand);
        var card_to_add = gameObject.player2hand[card_index_to_discard];
        //console.log(card_to_add);
        if(playerNumber == 1){
          card_to_add = gameObject.player1hand[card_index_to_discard];
        }
        var new_draw_list = gameObject.drawcard.slice(1);
        new_draw_list.unshift(card_to_add);
        console.log('NEW DRAW CARD LIST: ' + new_draw_list);
        setSpelledLetters([]);
        spelledListofIncides = [];

        let newData = {...gameObject, drawcard: new_draw_list}
        if(playerNumber == 1){
          newData = {...newData, player1prompt: 'WAITING FOR OPP', player2prompt: 'OPP DISCARDED', 
          state: 'p2', player1hand: new_hand}
        }else{
          newData = {...newData, player2prompt: 'WAITING FOR OPP', player1prompt: 'OPP DISCARDED', 
          state: 'p1', player2hand: new_hand}

        }
        set(gameRef, newData);

      }else if(playerNumber == 2 && gameObject.state == 'p2'){
        const card_index_to_discard = spelledListofIncides[0];
        const draw_card_to_add = gameObject.drawcard[draw_card_index];
        console.log('PLAYER' + playerNumber + ' IS DISCARDING: ' 
        + gameObject.player1hand[card_index_to_discard] + ' and is adding ' + draw_card_to_add);
        var new_hand = gameObject.player2hand;
        new_hand += draw_card_to_add;
        new_hand = new_hand.slice(0, card_index_to_discard) + new_hand.slice(card_index_to_discard + 1)
        console.log(new_hand);
        const card_to_add = gameObject.player2hand[card_index_to_discard];
        //console.log(card_to_add);
        var new_draw_list = gameObject.drawcard.slice(1);
        new_draw_list.unshift(card_to_add);
        console.log('NEW DRAW CARD LIST: ' +  new_draw_list);
        setSpelledLetters([]);
        spelledListofIncides = [];

        const newData = {...gameObject, drawcard: new_draw_list, player2hand: new_hand, state: 'p1', 
        player2prompt: 'WAITING FOR OPP', player1prompt: 'OPP DISCARDED' }
        set(gameRef, newData);
      }
      
      setMyTurn(false);
      setShuffleLimit(true);
    }
  };

  async function handleShuffle(){
    if(shuffleLimit){
      console.log('YOU CAN ONLY SHUFFLE ONCE');
      displayPrompt('YOU ALREADY SHUFFLED ONCE')
      return
    };
    console.log('SHUFFLING: ' + gameObject.drawcard[0] + ' new card: ' + gameObject.drawcard[1]);
    //setDraw_card_index(prev=>prev +1);

    if(gameObject.finalcard){   // SHUFFLING AFTER OPP HAS GONE OUT
      console.log('NO NEED TO SEND OBJECT TO OPP');
      const new_dc_list = gameObject.drawcard.slice(1);
      console.log('NEW LIST IS: ' + new_dc_list);
      setGameObject(prev => {
        return {...prev, drawcard: new_dc_list};
      });
      setShuffleLimit(true);
      return
    }

    console.log('NOT FINAL TURN - NORMAL SHUFFLE...')

    const new_draw_cards_list = gameObject.drawcard.slice(1);
    const gameRef = ref(database, 'games/' + currentGameID);
    console.log('NEW DRAW LIST = ' + new_draw_cards_list);
    let newData = {...gameObject, drawcard: new_draw_cards_list }
    if(playerNumber == 1){
      newData = {...gameObject, player1prompt: 'YOU SHUFFLED', drawcard: new_draw_cards_list}
      }else{
      newData = {...gameObject, player2prompt: 'YOU SHUFFLED', drawcard: new_draw_cards_list}
    }
    setGameObject(newData);
    await set(gameRef, newData);
    console.log('NEW GAME OBJECT');
    console.log(newData);
    setShuffleLimit(true);

  }

  function handleClickPrompt(){
    console.log('CLICKED PROMPT: ');
    if(promptActive){
      console.log('ABLE TO BE CLICKED');
      const gameRef = ref(database, 'games/' + currentGameID);
      // NEW GAME NEW DECK
      var new_round_number = gameObject.round + 1;
      const deck = createDeck();
      const first10 = deck.slice(0, new_round_number);
      const second10 = deck.slice(new_round_number, new_round_number * 2);
      const drawC = deck.slice(20, 100);
      const p1hand = first10.join('');
      const p2hand = second10.join('');
      // NEW GAME OBJECT
      const promptNew = 'ROUND ' + (gameObject.round + 1)
      const newData = {player1points: gameObject.player1points, state: 'new', player1hand: p1hand, player2hand: p2hand,
      player2points: gameObject.player2points, player2prompt: promptNew, player1prompt: promptNew,
      drawcard: drawC, round: new_round_number, player1: 'Danny', player2: 'Nata'}
      set(gameRef, newData);
      handleClear();
      //setShuffleLimit(false);

    }
  }

  useEffect(() => {
    if (gameObject && gameObject.round !== undefined) {
      const totalLength = spelledLetters.length + spelledLetters2.length + spelledLetters3.length;
      if (totalLength == gameObject.round) {
        setSpellLimit(true);
      } else {
        setSpellLimit(false);
      }
    }
  }, [spelledLetters, spelledLetters2, spelledLetters3, gameObject]);
  
  useEffect(() => {
  
    const gameObjectRef = ref(database, 'games/' + currentGameID);
    // Listener for changes in gameObject data
    const unsubscribe = onValue(gameObjectRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        console.log('USE EFFECT CALLED');
        console.log(data);
        const gameState = data.state;
        let shouldUpdateGameObject = true;

        // Check if finalcard exists and your turn now
        if (data.finalcard && ((gameState === 'p1' && playerNumber === 1) 
          || (gameState === 'p2' && playerNumber === 2))) {
          // Modify the gameObject for the receiver
          setDraw_card_index(0);    // is this necessary now?
          const updatedGameObject = {
            ...data,
            drawcard: [data.finalcard, ...data.drawcard.slice(1)] // Set drawcard to an array with finalcard as its only element
          };
          setLastTurn(true);
          setGameObject(updatedGameObject);
          shouldUpdateGameObject = false;
          setShuffleLimit(false);

        }

        if (shouldUpdateGameObject) {
          setGameObject(data); // Update gameObject normally for other cases
        }
        switch (gameState) {
          case 'p1':
            console.log('ITS PLAYER 1s TURN NOW');
            if(playerNumber == 1){
              setMyTurn(true);
              setPromptActive(false);
              setShuffleLimit(false);
            }
            break;
          case 'p2':
            console.log('ITS PLAYER 2s TURN NOW')
            if(playerNumber == 2){
              setMyTurn(true)
              setPromptActive(false);
              setShuffleLimit(false);
            }
            break;
          case 'new':
            if (data.round % 2 == 0){  // if round is even
              if(playerNumber == 2){
                setMyTurn(true)
                setShuffleLimit(false);
              }
              if(playerNumber == 1){
                setMyTurn(false)
                setShuffleLimit(true);
              }
            }else{
              if(playerNumber == 1){
                setMyTurn(true)
                setShuffleLimit(false);
              }
              if(playerNumber == 2){
                setMyTurn(false)
                setShuffleLimit(true);
              }
            }
            setPromptActive(false);
            handleClear();
            
            break;
          case 'over':
            // START NEW ROUND or end game
            console.log('THIS ROUND IS OVER!!  PROGRESSING TO ROUND: ' + (data.round + 1));
            console.log('PLAYER 1: ' + data.player1points + '     PLAYER 2: ' + data.player2points);
            setPromptActive(true);


            if(data.round + 1  > 10){
              console.log('THE ENTIRE GAME IS OVER!!!!!');
              /////////  END THE GAME HERE /////////////
              if(gameObject.player1points > gameObject.player2points){
                SetWinnerNumber(1);
              }else{SetWinnerNumber(2)}
              SetGamefinished(true);
              /// DISPLAY FINAL SCREEN 

            }

            break;    
        }
      }
    });

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [currentGameID, setGameObject]);

  return(
    !gameOver ? 
    <div className='GameContainer'>
      <div className='scoreboardContainer' 
      style={{ backgroundColor: playerNumber === 1 ? 'rgb(110, 175, 255)' : 'rgb(235, 75, 75)' }}>
        <div className='score'>
          <div>P1 SCORE <br></br> {gameObject && gameObject.player1points}</div>
          <div className='roundNumber'>ROUND {gameObject && gameObject.round}</div>
          <div>P2 SCORE<br></br>{gameObject && gameObject.player2points}</div>
        </div>
        <div className='spelled'>
          <span>PLAYER: {playerNumber && playerNumber}</span>
          <span className='ID'>GAME ID: {currentGameID && currentGameID}</span>
        </div>
      </div>
      <div className='playContainer'>
      <div className='prompt'>
        {gameObject ? (
          playerNumber === 1 ? 
          <span onClick={handleClickPrompt}>{gameObject.player1prompt}</span> : 
          <span onClick={handleClickPrompt}>{gameObject.player2prompt}</span>
        ) : null}
      </div>
      <div className='spellArea'>                       
        <div className='roundScore'>ROUND SCORE: {gameObject && playerNumber == 1 ? 
        roundPoints : roundPoints}
        </div>
        <div className='spelledWord'>
          {spelledLetters.map(index => (
            <span key={index} className='letterTile2'>
              {index === 11 
                ? gameObject.drawcard[draw_card_index] 
                : (playerNumber === 1 ? gameObject.player1hand[index] : gameObject.player2hand[index])}
                <span className='tilePoint'>{index === 11 
                  ? letterScores[gameObject.drawcard[draw_card_index]] 
                  : (playerNumber === 1 ? letterScores[gameObject.player1hand[index]] 
                  : letterScores[gameObject.player2hand[index]])}
                </span>
            </span>
          ))}
        </div>
        <div className='spelledWord'>
          {spelledLetters2.map(index => (
            <span key={index} className='letterTile2'>
              {index === 11 
                ? gameObject.drawcard[draw_card_index] 
                : (playerNumber === 1 ? gameObject.player1hand[index] : gameObject.player2hand[index])}
                <span className='tilePoint'>{index === 11 
                  ? letterScores[gameObject.drawcard[draw_card_index]] 
                  : (playerNumber === 1 ? letterScores[gameObject.player1hand[index]] 
                  : letterScores[gameObject.player2hand[index]])}
                </span>
            </span>
            ))}
        </div>
        <div className='spelledWord'>
          {spelledLetters3.map(index => (
            <span key={index} className='letterTile2'>
              {index === 11 
                ? gameObject.drawcard[draw_card_index] 
                : (playerNumber === 1 ? gameObject.player1hand[index] : gameObject.player2hand[index])}
                <span className='tilePoint'>{index === 11 
                  ? letterScores[gameObject.drawcard[draw_card_index]] 
                  : (playerNumber === 1 ? letterScores[gameObject.player1hand[index]] 
                  : letterScores[gameObject.player2hand[index]])}
                </span>
            </span>
          ))}
        </div>

        <div className='drawButtonContainer'>
          <span onClick={handleClear} className='uiButton clear'>CLEAR</span>
          <span onClick={handleClickSpellBtn} className='uiButton spell'>ADD WORD</span>
          <span onClick={handleEndTurn} className={`uiButton end ${myTurn ? '' : 'inactive'}`}>END TURN</span>
          <span onClick={handleDiscard} className={`uiButton discard ${myTurn ? '' : 'inactive'}`}>DISCARD</span>
          <span onClick={handleShuffle} 
            className={`uiButton shuffle ${myTurn ? '' : 'inactive'}`}>SHUFFLE</span>
          <span onClick={() => handleTouch(11)} className='drawButton'
            style={gameObject ? {
              display: spelledLetters.includes(11) || 
              spelledLetters2.includes(11) || 
              spelledLetters3.includes(11) ? 'none' : 'flex'
            } : {}}
          >
            {gameObject && gameObject.drawcard[draw_card_index]}
            <span className='tilePoint'>
              {gameObject && letterScores[gameObject.drawcard[draw_card_index]]}
            </span>
          </span>
        </div>
        {
        gameObject && (
          <div className='yourHand'>
          {(playerNumber === 1 ? gameObject.player1hand 
          : gameObject.player2hand).split('').map((char, index) => (
            <span
              className='letterTile'
              key={index}
              onClick={() => handleTouch(index)}
              style={{ 
                display: spelledLetters.includes(index) || spelledLetters2.includes(index) || 
                spelledLetters3.includes(index) ? 'none' : 'flex'
              }}
            >
              {char}
              <span className='tilePoint'>{letterScores[char]}</span>
            </span>
          ))}
        </div>
      )
    }
        <div className='uiContainer'>
          
        </div>
        </div>
      </div>
    </div>

    : <GameOver/>
  )
}

function HomeScreen({setPlayerNumber, setCurrentGameID, setGameRunning, setLoginID, setGameObject}) {

  const deck = createDeck();
  const first10 = deck.slice(0, starting_round_number);
  const second10 = deck.slice(starting_round_number,starting_round_number * 2);
  const drawC = deck.slice(20, 100);
  const p1hand = first10.join('');
  const p2hand = second10.join('');

  const newGameData = {
    player1: 'Danny',
    player1points: 0,
    player1hand: p1hand,
    player1prompt: 'Waiting For Player 2',
    player2: 'Phil',
    player2points: 0,
    player2hand: p2hand,
    player2prompt: 'YOU GO FIRST',
    state: 'new',
    round: starting_round_number,
    drawcard: drawC

}

  async function createGameOnClick(){
    if(newgameIdInputRef.current.value.length < 3){return}  // ADD ERROR HANDLING
    setGameRunning(true);
    console.log('Submitted Game ID:', newgameIdInputRef.current.value);
    const loadID = newgameIdInputRef.current.value;
    const UID = await signIn();
    const gamesRef = ref(database, 'games/' + loadID)
    set(gamesRef, newGameData);
    console.log('CLICKED' + UID)
    setPlayerNumber(1);
    const GameData = await getGameData(loadID);
    setCurrentGameID(loadID);
    setGameObject(GameData);
  }
  async function loadGameOnClick(){
    if(gameIdInputRef.current.value.length < 3){return}  // ADD ERROR HANDLING
    setGameRunning(true);
    console.log('Submitted Game ID:', gameIdInputRef.current.value);
    const loadID = gameIdInputRef.current.value;
    const GameData = await getGameData(loadID);
    setCurrentGameID(loadID);
    setGameObject(GameData);
    if(GameData.state === 'new'){
      console.log('I AM THE SECOND PLAYER')
      setPlayerNumber(2);
    }else{
      console.log('I AM NOT SECOND PLAYER');
      
    }

  }
  async function signIn() {
    try {
      const userCredential = await signInAnonymously(auth);
      console.log('Signed in anonymously', userCredential.user.uid);
      setLoginID(userCredential.user.uid);
      return userCredential.user.uid;
    } catch (error) {
      console.error('Error signing in anonymously:', error);
    }
  }

  async function getGameData(ID){
    const dataRef = ref(database,  'games/' + ID);
    try {
      const snapshot = await get(dataRef);
      if (snapshot.exists()) {
        //console.log(snapshot.val());
        return snapshot.val();
      } else {
        console.log("No data available for key:", ID);
        return null;
      }
    }catch(err){console.log(err)}
  }

  const gameIdInputRef = useRef(null);
  const newgameIdInputRef = useRef(null);
  
  return (
    <div className="App">
      <div className="buttonsContainer">
        <input ref={newgameIdInputRef} placeholder="Create Game ID" className="gameIdInput"></input>
        <button onClick={createGameOnClick} className="createGameBtn">CREATE GAME</button>
        <input ref={gameIdInputRef} placeholder="Enter Game ID to Load" className="gameIdInput"></input>
        <button onClick={loadGameOnClick} className="loadGameBtn">LOAD GAME</button>
      </div>
      <h1>AlphaBattle</h1>
    </div>
  )
}

function App() {

  const [gameRunning, setGameRunning] = useState(false);
  const [loginID, setLoginID] = useState();
  const [gameObject, setGameObject] = useState();
  const [currentGameID, setCurrentGameID] = useState();
  const [playerNumber, setPlayerNumber] = useState();
  const [gameFinished, SetGamefinished] = useState(false);
  const [winnerNumber, SetWinnerNumber] = useState(0);

  return (
     !gameRunning ? <HomeScreen setPlayerNumber={setPlayerNumber} setCurrentGameID={setCurrentGameID} setGameObject={setGameObject} setLoginID={setLoginID} setGameRunning={setGameRunning}/> 
     :
     !gameFinished ?
     <Game
          SetWinnerNumber={SetWinnerNumber}
          SetGamefinished={SetGamefinished}
          setGameObject={setGameObject}
          playerNumber={playerNumber}
          currentGameID={currentGameID}
          gameObject={gameObject}
          setGameRunning={setGameRunning}
          loginID={loginID}
        />
     :
     <GameOver gameObject={gameObject} winnerNumber={winnerNumber} playerNumber={playerNumber} />
  );
}

export default App;

/*
                                          NOTES/    BUGS/   IDEAS/ RULES/

IF YOU ARE ON YOUR LAST TURN AND YOU USE LESS THAN YOUR TOTAL TILES, THE OTHER TILES ARE MINUSED 

CHECK IF ALL WORDS ARE SPELLED CORRECTLY BEFORE ENDING TURN (when someone goes out first)

CREATE A ? BUTTON THAT BRINGS YOU TO THE RULES PAGE

CLEAR function DISPLAYS PREVIOUS PROMPT OR DEFAULT PROMPT

Add loading splash screen to display aftyer create game is clicked (there's a delay)

Make tooltip for definition of words

RULES:

3 letters minimum per spelled word  

start on round 4



*/